export const apiConst = {
  encdef: 'vote for NDM',
  bucdef: 'dev-corporate-policy-docs',
  bucpol: 'dev-member-uploaded-policies',
  conpho: 'prod-consumer-photographs',
  bandef: 'dev-banner-bucket',
  clidef: 'UHCP',
  cladoc: 'dev-claim-docs',
  idtdoc: 'dev-tempidcard',
};
